// src/TermsAndConditions.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "./contexts/CartContext";
import { useTheme } from "./contexts/ThemeContext";
import { ShoppingCart } from "lucide-react";
import logo from "./assets/logo.png";

export default function TermsAndConditions() {
  const navigate = useNavigate();
  const { itemCount } = useCart();
  const { darkMode, setDarkMode } = useTheme();

  return (
    <div className={darkMode ? "dark" : ""}>
      <div className="min-h-screen bg-gradient-to-b from-white to-pink-50 dark:from-gray-900 dark:to-gray-800 text-gray-800 dark:text-gray-200 font-sans">

        {/* HEADER */}
        <header className="w-full py-4 shadow-sm bg-white/60 dark:bg-gray-900/60 backdrop-blur-xl sticky top-0 z-50">
          <div className="max-w-6xl mx-auto flex items-center justify-between px-4">
            {/* Logo */}
            <div className="flex items-center gap-3 cursor-pointer" onClick={() => navigate("/")}>
              <img src={logo} alt="Bubble Butter Logo" className="h-14 w-auto object-cover rounded-lg shadow-sm" />
              <h1 className="text-2xl font-bold text-pink-600 dark:text-pink-300">Bubble Butter</h1>
            </div>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center gap-6">
              <button onClick={() => navigate("/")} className="hover:text-pink-600 dark:hover:text-pink-300 font-semibold">
                Home
              </button>
              <button onClick={() => navigate("/products")} className="hover:text-pink-600 dark:hover:text-pink-300 font-semibold">
                Products
              </button>
              <button
                onClick={() => setDarkMode(!darkMode)}
                className="p-2 rounded-full bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 transition shadow-sm"
              >
                {darkMode ? "🌙" : "☀️"}
              </button>
            </div>

            {/* Mobile Menu */}
            <div className="md:hidden flex items-center gap-4">
              {/* Home Icon */}
              <button
                onClick={() => navigate("/")}
                className="h-10 w-10 flex items-center justify-center rounded-full bg-gray-200 dark:bg-gray-700 shadow-md hover:bg-gray-300 dark:hover:bg-gray-600 transition"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                  className="w-6 h-6 text-pink-600 dark:text-pink-300"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-10 0h10"
                  />
                </svg>
              </button>

              {/* Theme Toggle */}
              <button
                onClick={() => setDarkMode(!darkMode)}
                className="p-2 rounded-full bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 transition"
              >
                {darkMode ? "🌙" : "☀️"}
              </button>
            </div>
          </div>
        </header>

        {/* CONTENT */}
        {/* CONTENT */}
        <main className="max-w-4xl mx-auto px-4 py-10">
          <h2 className="text-3xl font-bold mb-6 text-pink-600 dark:text-pink-300">
            Terms & Conditions
          </h2>

          <p className="mb-4 text-sm opacity-80">
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <section className="space-y-6 leading-relaxed">
            <p>
              By accessing or purchasing from Bubble Butter, you agree to the
              following terms and conditions.
            </p>

            <div>
              <h3 className="text-xl font-semibold mb-2">Products</h3>
              <p>
                All products are handmade and natural. Slight variations in
                color, texture, or fragrance are normal and not considered
                defects.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-2">Orders & Payments</h3>
              <p>
                Orders are confirmed only after successful payment. Prices are
                subject to change without prior notice.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-2">Shipping</h3>
              <p>
                Delivery timelines are estimates and may vary due to courier or
                location-related delays.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-2">Returns & Refunds</h3>
              <p>
                Due to the nature of personal care products, returns are accepted
                only for damaged or incorrect items reported within 48 hours of
                delivery.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-2">Limitation of Liability</h3>
              <p>
                Bubble Butter is not liable for any allergic reactions. Please
                review ingredient lists carefully before use.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-2">Contact</h3>
              <p>
                For any questions regarding these terms, contact us at: <br />
                <strong>📧 bubblebutter.help@gmail.com</strong>
              </p>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}
